module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2B9WI"))).then(() => parcelRequire('1iHdE'));